<template>
  <v-app dark>
    <navbar @toogleSidebar="toggleSidebar" />
    <sidebar
      v-if="isApproved"
      v-model="sidebar"
    />
    <v-main>
      <div class="default-wrapper">
        <router-view :key="$route.fullPath" />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import cookie from 'vue-cookie';
import OrderToastComponent from '@/components/shared/OrderToastComponent.vue';
import Navbar from '../components/app/navbar/Navbar.vue';
import Sidebar from '../components/app/sidebar/Sidebar.vue';
import ordersAPI from '../api/orders';

export default {
  name: 'DefaultLayout',
  components: { Navbar, Sidebar },
  data: () => ({
    sidebar: true,
    checkOrderInterval: null,
    waitTime: 0,
    orderNotifyContent: {
      order_id: 1,
      player_id: null,
      coach_type: null,
      price: 0,
      wait_time: 120,
    },

  }),

  computed: {
    isApproved() {
      return this.$store.getters.isApproved;
    },

    toastComponent() {
      return {
        component: OrderToastComponent,
        props: {
          content: this.orderNotifyContent,
        },
        listeners: {
          take: this.takeOrder,
          details: this.openDetailOrder,
        },
      };
    },
  },

  mounted() {
    this.sidebar = cookie.get('sidebar') === 'true';
    this.checkOrderInterval = setInterval(this.checkNewOrders, 5000);
  },

  beforeDestroy() {
    clearInterval(this.checkOrderInterval);
  },

  methods: {

    takeOrder(id) {
      ordersAPI.take(id)
        .then((response) => {
          if (response.data.success) {
            this.$toast.clear();
            this.$router.push(`/orders/details/${id}`);
          }
        });
    },

    openDetailOrder(id) {
      this.$toast.clear();
      this.$router.push(`/orders/details/${id}`);
    },

    toggleSidebar() {
      this.sidebar = !this.sidebar;
      cookie.set('sidebar', this.sidebar);
    },

    showOrderNotify() {
      this.$toast(this.toastComponent, {
        timeout: this.orderNotifyContent.wait_time * 1000,
        closeOnClick: false,
        pauseOnHover: false,
        icon: false,
        draggable: false,
        toastClassName: 'z-toast-wrapper',
      });
    },

    checkNewOrders() {
      this.$store.dispatch('CHECK_NEW_ORDERS')
        .then((response) => {
          if (response.data.success) {
            this.orderNotifyContent = response.data.data;
            this.showOrderNotify();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .default-wrapper {
    max-width: 1300px;
    padding: 12px 15px;
  }
</style>
